export default function arePropsEqual(prevProps, nextProps) {
  return (
    prevProps.storeData?.address === nextProps.storeData?.address &&
    prevProps.storeData?.latitude === nextProps.storeData?.latitude &&
    prevProps.storeData?.longitude === nextProps.storeData?.longitude
  );
}
